import { useMemo } from 'react';
import { Field, useField, useFormikContext } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';

import { Section } from '..';
import { Field as TField, FieldType } from '../../../../types/form-fields';
import { CheckboxField, FormRow, InputField } from '../../../fields';
import { TextVariables } from '../../../form-editor/text-variables';

const EMAIL_VARIABLES = ['code', 'name', 'description'];
const textValueSchema = Yup.string().optional().max(255, 'Should be < 1023 characters');

export const EmailToWinnerIntegration = () => {
  const [{ value: sendEmailToWinner }] = useField<boolean>('campaign.sendEmailToWinner');
  const [{ value: winnerEmailText }, , winnerEmailTextHelpers] = useField<string>('campaign.winnerEmailText');
  const [fields] = useField<{ fields: TField[] }>('campaign.formFields');

  const { submitForm } = useFormikContext();

  const hasEmailField = useMemo(() => {
    return fields.value.fields.some((field) => field.type === FieldType.EmailInput);
  }, [fields]);

  const validate = (value: string, schema: Yup.AnySchema) => {
    try {
      schema.validateSync(value);
    } catch (error) {
      return (error as any).message;
    }
  };

  if (!hasEmailField) {
    return null;
  }

  return (
    <Section>
      <Field name="campaign.sendEmailToWinner" component={CheckboxField} label="Отправлять приз на почту" />
      <Typography color="textSecondary" sx={{ fontSize: '14px', marginLeft: '28px', marginBottom: '20px' }}>
        Если пользователь что-то выиграл - мы отправим ему выигранный приз на указанный email
      </Typography>

      {sendEmailToWinner && (
        <FormRow>
          <Field
            name="campaign.winnerEmailText"
            component={InputField}
            multiline
            minRows={3}
            validate={(value: string) => validate(value, textValueSchema)}
            sx={{ width: '100%' }}
          />
          <TextVariables
            variables={EMAIL_VARIABLES}
            onVariableClick={(variable) => {
              winnerEmailTextHelpers.setValue(`${winnerEmailText || ''}${variable}`);
              submitForm();
            }}
          />
        </FormRow>
      )}
    </Section>
  );
};
